import React from "react";

export const SkeletonTwo = () => {
  return (
    <div className="relative flex flex-col py-8 px-2 gap-4 h-full">
      <div className="w-full p-5 mx-auto bg-neutral-950 shadow-2xl group rounded-2xl border border-neutral-800">
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <div className="w-5 h-5 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0">
              <svg
                className="w-3 h-3 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
            <span className="text-[11px] font-semibold text-neutral-200">
              Call Summary
            </span>
          </div>
          <span className="text-[10px] bg-green-900/60 text-green-400 px-2 py-0.5 rounded-full border border-green-800/50 font-medium">
            Interested ✓
          </span>
        </div>

        {/* AI summary */}
        <div className="mb-4 p-3 bg-neutral-900 rounded-xl border border-neutral-800">
          <p className="text-[11px] text-neutral-400 leading-relaxed">
            Lead expressed strong interest in the enterprise plan. Requested
            pricing details and asked about onboarding timeline and team seats.
          </p>
        </div>

        {/* Next steps */}
        <div className="mb-4">
          <p className="text-[10px] font-semibold text-neutral-500 uppercase tracking-wider mb-2">
            Next Steps
          </p>
          <div className="space-y-2">
            {[
              "Send pricing proposal by EOD",
              "Schedule product demo for next week",
              "Loop in account executive",
            ].map((step, i) => (
              <div key={i} className="flex items-center gap-2">
                <div className="w-1.5 h-1.5 rounded-full bg-blue-500 flex-shrink-0" />
                <span className="text-[11px] text-neutral-400">{step}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <div className="flex items-center justify-between pt-3 border-t border-neutral-800">
          <span className="text-[10px] text-neutral-600">
            Generated automatically by Coldfire AI
          </span>
          <span className="text-[10px] text-neutral-600">just now</span>
        </div>
      </div>
    </div>
  );
};
